import { WebAPIClient } from "api";
import { ApiEndPoints } from "api/api-end-points";
import { BrandingData } from "admin-portal/settings/branding";
import { BaseSearchParam } from "models/base-search-param";
import { Tenant } from "models/tenant/tenant"
import { APIResult } from "models/api-results";
import { User, UserTenant, UserTenantAdminAssign } from "models/user/user";
import { Feature, SubscriptionPlan } from "models/subscription/subcription-plan";



export async function TenantSearch(param: any, sort?: string, pageSize?: number, pageNumber?: number): Promise<APIResult<Tenant[]>> {
    const searchParams = new BaseSearchParam(param, sort, pageSize, pageNumber);
    const queryString = searchParams.buildQueryString();

    const apiUrl = `${ApiEndPoints.tenant_search}${queryString}`;
    return await WebAPIClient.getData<Tenant[]>(apiUrl);
}

export async function CreateTenant(param: Tenant): Promise<APIResult<Tenant>> {
    return await WebAPIClient.postData<Tenant>(ApiEndPoints.tenant_create, param);
}
export async function UpdateTenant(param: Tenant): Promise<APIResult<Tenant>> {
    return await WebAPIClient.patchData<Tenant>(ApiEndPoints.tenant_update.replace("{id}", (param?.id ?? "")), param);
}
export async function GetTenantDetails(id: string): Promise<APIResult<Tenant>> {
    return await WebAPIClient.getData<Tenant>(ApiEndPoints.tenant_get.replace("{id}", id));
}
export async function AddUserToTenant(tenantId: string, user: User): Promise<APIResult<User>> {
    return await WebAPIClient.postData<User>(ApiEndPoints.tenant_add_users.replace("{id}", tenantId), user);
}

export async function GetTenantUsers(tenantId: string, param: any, sort?: string, pageSize?: number, pageNumber?: number) {
    const searchParams = new BaseSearchParam(param, sort, pageSize, pageNumber);
    const queryString = searchParams.buildQueryString();

    const apiUrl = `${ApiEndPoints.tenant_user_list.replace("{id}", tenantId)}${queryString}`;
    return await WebAPIClient.getData<User[]>(apiUrl);
}
export async function GetSystemUsers(param: any, sort?: string, pageSize?: number, pageNumber?: number) {
    const searchParams = new BaseSearchParam(param, sort, pageSize, pageNumber);
    const queryString = searchParams.buildQueryString();

    const apiUrl = `${ApiEndPoints.system_user_list}${queryString}`;
    return await WebAPIClient.getData<User[]>(apiUrl);
}

export async function AssignAdminToTenant(tenantId: string, userTenant: UserTenantAdminAssign): Promise<APIResult<User>> {
    return await WebAPIClient.postData<User>(ApiEndPoints.tenant_user_assign_admin.replace("{id}", tenantId), userTenant);
}


//Subscription
export async function GetFeatures(): Promise<APIResult<Feature[]>> {
    return await WebAPIClient.getData<Feature[]>(ApiEndPoints.subscription_features);
}
export async function GetSubscriptionPlans(): Promise<APIResult<SubscriptionPlan[]>> {
    return await WebAPIClient.getData<SubscriptionPlan[]>(ApiEndPoints.subscription_plans);
}
export async function GetSubscriptionPlan(subscriptionId: string): Promise<APIResult<SubscriptionPlan>> {
    return await WebAPIClient.getData<SubscriptionPlan>(ApiEndPoints.subscription_plan.replace("{id}", subscriptionId));
}
export async function AddSubscriptionPlan(plan: SubscriptionPlan): Promise<APIResult<SubscriptionPlan>> {
    return await WebAPIClient.postData<SubscriptionPlan>(ApiEndPoints.subscription_plans_create, plan);
}
export async function UpdateSubscriptionPlan(subscriptionId: string, plan: SubscriptionPlan): Promise<APIResult<SubscriptionPlan>> {
    return await WebAPIClient.putData<SubscriptionPlan>(ApiEndPoints.subscription_plans_update.replace("{id}", subscriptionId), plan);
}